import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';
import { IssueFormAppManager } from 'apps/issueTracker/issueForm/appManager';

@observer
export class IssueForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new IssueFormAppManager(
      modalStore.props.parent,
      modalStore.props,
    );
  }

  render() {
    const { issueFormApp } = this.appManager;
    const { form } = issueFormApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={this.appManager.Submit}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
